import { ReactNode, FC } from 'react';
import { SharedTooltip } from '../../shared/SharedTooltip';
import styles from './PdpRespSidebarSellerInfoTooltip.scss';

type Props = {
    title?: ReactNode;
    ariaLabel?: string;
    description: ReactNode;
    dataTn?: string;
};

export const PdpRespSidebarSellerInfoTooltip: FC<Props> = ({
    title,
    ariaLabel,
    description,
    dataTn,
    children,
}) => {
    return (
        <SharedTooltip
            ariaLabel={ariaLabel}
            wrapperClass={styles.wrapper}
            linkClass={styles.tooltipTrigger}
            dataTn={dataTn}
            align="right"
            direction="bottom"
            tooltipContent={
                <>
                    {title && <span className={styles.title}>{title}: </span>}
                    {description}
                </>
            }
        >
            {children}
        </SharedTooltip>
    );
};
